





























import { Vue, Component, Prop } from "vue-property-decorator";
import Vehicle from "@/data/models/Vehicle";
import { UserModule } from "@/store/modules/UserModule";
import { getBranchesOfClient } from "@/data/repository/ClientRepository";

@Component({
  components: {},
})
export default class VehicleDevicesItemComponent extends Vue {
  @Prop() readonly vehicle!: Vehicle;
  @Prop() elevation!: number;
  @Prop() onOpenDetails!: (vehicle: Vehicle) => void;
  @Prop({ default: "" })
  backgroundStyle!: string;

  get branchName() {
    const branchNumber = this.vehicle.branch;

    if (!branchNumber) {
      return "";
    }

    const branches = getBranchesOfClient();
    const vehicleBranch = branches.find(branch => branchNumber.toString() === branch.branchNumber.toString());

    return vehicleBranch?.name ?? "";
  }

  get allocatedUser() {
    return UserModule.userNicknameOrLastNameOrStaffNumber(this, this.vehicle.allocatedUser);
  }

  get numberOfDevices() {
    return this.vehicle.devices?.length ?? 0;
  }
}
